module.exports = __webpack_public_path__ + "media/images/icons/material/cv-847401fe533bca6eb6107708bb500b14.svg";